/// <amd-module name="Build/Queue-Panel/Constants" />

export namespace GitConstants {
    export const RefsHeadsPrefix = "refs/heads/";
    export const RefsTagsPrefix = "refs/tags/";
    export const RefsPrefix = "refs/";
    export const ShortenedCommitHashLength = 8;
}